import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rechargecash",
  "use": "icon-rechargecash-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rechargecash\"><path d=\"M717.3 491c-37.3 0.8-68.2 13.8-92.7 38.9s-37.1 56.9-37.9 95.2c0.8 38.3 13.4 70.1 37.9 95.2s55.4 38.1 92.7 38.9H960V877c0 40.9-33.1 74-74 74H138c-40.9 0-74-33.1-74-74V373.4c0-40.9 33.1-74 74-74h748c40.9 0 74 33.1 74 74V491H717.3z m37.4 198.7h-37.3c-15.6-0.8-28.6-6.4-39.1-16.9s-15.8-23.5-15.8-39.1 5.3-28.6 15.8-39.1 23.5-16.1 39.1-16.9h37.3c15.6 0.8 28.6 6.4 39.1 16.9s15.8 23.5 15.8 39.1-5.3 28.6-15.8 39.1-23.6 16.1-39.1 16.9z m-62-595.5l118 147.5h-448L618.8 81.6c24.2-15.2 56-9.8 73.9 12.6z\" p-id=\"28102\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/rechargecash.svg
// module id = 1ang
// module chunks = 13